import React from 'react';

import FieldController from '../../../controller/FieldController';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import { Table } from 'react-bootstrap';

class LeadScoreConditionView extends React.Component {

  constructor(props) {
    super(props);
    const fields = props.fields;
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
        type: fields[i].field_type, label: fields[i].label_name });
    }
    const conditions = [];
    this.value={field:'',condition:'',conditions,text:'',fOpt:'',select:'',from:'',to:'',andor:false , score:0 , type:0};
    const filters = this.getConditions(props.value);
    this.state = { filters };
  }

  //componentDidUpdate(props) {
  UNSAFE_componentWillReceiveProps(props) {
    //if(!this.isComponentUpdate) {
      const filters = this.getConditions(props.value);
      this.setState({ ...this.state, filters });
      this.props.onConditionChanged(filters);
      this.isComponentUpdate = true;
    //}
  }

  getConditions = value => 
    value.map(value => {
      const field = this.fieldList.find(field => field.value === value.field);
      if(field === undefined) return { ...value };
      const conditions = FieldController.getConditions(field.type);
      const condition = conditions.find(condition => condition.value === value.condition);
      const fOpt = this.getOptionField(field.type, value.condition);
      const options = this.getOptions(fOpt, field.value, value.value);
      const andor = value.andor ? value.andor : false;
      const score = value.score ? value.score : 0;
      const type = value.type ? value.type : 0;
      value = value.value;
      let from = null, to = null;
      if((field.type === Const.Decimal || field.type === Const.Number) && value) {
        from = value.split(Const.Opt)[0];
        to = value.split(Const.Opt)[1];
      }
      return { field, condition, conditions, value, ...fOpt, ...options, andor, from, to , score , type};
    });

  getOptionField = (type, condition) => {
    const isText = FieldController.showTextFilter(type, condition);
    const isDate = type === Const.Date || type === Const.DateTime;
    const isNumber = type === Const.Decimal || type === Const.Number;
    const isFrom = FieldController.showDateFrom(type, condition);
    const isTo = FieldController.showDateTo(type, condition);
    const isCity = FieldController.showCity(type, condition);
    const isState = FieldController.showState(type, condition);
    const isCountry = FieldController.showCountry(type, condition);
    const isSelect = FieldController.showSelect(type, condition);
    return { isText, isDate, isNumber, isFrom, isTo, isCity, isState, isCountry, isSelect };
  }

  getOptions = (fOpt, field, value) => {
    if(!value) value = '';
    let select = '', options = [], from = null, to = null;
    if(fOpt.isCity) {
      options = FieldController.getOptions({ field_type: Const.City });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isState) {
      options = FieldController.getOptions({ field_type: Const.State });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isCountry) {
      options = FieldController.getOptions({ field_type: Const.Country });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isSelect) {
      options = FieldController.getOptions(this.props.model.fields[field]);
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isFrom || fOpt.isTo) {
      if(value !== '') {
        const dates = value.split(Const.Opt);
        from = Util.serverStringDateTimeToDate(dates[0]);
        to = Util.serverStringDateTimeToDate(dates[1]);
      }
    }
    return { select, options, from, to};
  }



  render() {
    const typeOptions = [{label:"Add", value:1},{label:"Subtract", value:2}];
    return (
    < div className='col-md-12'>
    <Table className="table-th-color p-2"  bordered> 
      <thead>
        <tr>
            <th>Field</th>
            <th>Condition</th>
            <th>Type</th>
            <th>Score</th>
         </tr>
      
      </thead>
      <tbody>
       {this.state.filters.map((filter, i) =>
        <tr key={`condition_${i}`}>
          <td>{filter.field.label}</td>
          <td>condition: ({filter.condition.label}) , value : 
             { (filter.isText || filter.isNumber) && filter.value }
            { (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
              && filter.select.constructor.name === 'Object' && filter.select.label } 
            { (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
              && filter.select.constructor.name === 'Array'
              && filter.select.map(tmp => tmp.label).join(`${Const.Comn} `) }</td>
            <td>{typeOptions.find(opt => opt.value === filter.type)?.label}</td>
            <td>{filter.score}</td>
        </tr>
       )}
      </tbody>
    
    </Table>
    </div>);
  }
}
export default LeadScoreConditionView;